import React, { useState } from 'react';
import { useAuth } from '../AuthProvider';
import AuthShell, { Label, Input, PrimaryButton, ErrorBanner } from '../AuthShell';

export default function MfaVerifyPage() {
  const { verifyMfa, logout } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await verifyMfa(code.trim());
    } catch (err) {
      setError(
        err?.detail === 'invalid_mfa_code' ? 'That code didn\'t match. Try again.' :
        err?.detail === 'mfa_locked' ? 'Too many attempts. Try again in a few minutes.' :
        err?.message || 'Could not verify code.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Two-factor authentication"
      subtitle="Enter the 6-digit code from your authenticator app."
      footer={<button onClick={logout} className="underline hover:text-continuum-500">Sign in as someone else</button>}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <ErrorBanner>{error}</ErrorBanner>
        <div>
          <Label htmlFor="code">Authenticator code</Label>
          <Input
            id="code"
            inputMode="numeric"
            autoComplete="one-time-code"
            required
            maxLength={6}
            pattern="[0-9]{6}"
            autoFocus
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            className="tracking-widest text-center font-mono text-lg"
          />
        </div>
        <PrimaryButton type="submit" loading={loading}>Verify</PrimaryButton>
      </form>
    </AuthShell>
  );
}
